<div *ngIf="patientAttachment.contentProcessing"
      class="alert mb-1"
      [class.alert-warning]="requiresRefresh"
      [class.alert-info]="!requiresRefresh">

  <div class="row">
    <div class="col-auto d-flex align-items-center">
      <mat-icon *ngIf="requiresRefresh" class="alert-icon text-warning">
        warning
      </mat-icon>

      <mat-icon *ngIf="!requiresRefresh" class="info-icon">
        info
      </mat-icon>
    </div>

    <div class="col d-flex align-items-center">
      <p class="m-0" *ngIf="requiresRefresh">
        The system has completed processing this document!
      </p>

      <p class="m-0" *ngIf="!requiresRefresh">
        The system is processing this document.
      </p>
    </div>

    <div class="col actions">
      <button
        class="btn btn-primary"
        [class.invisible]="!requiresRefresh"
        [disabled]="refreshing"
        (click)="onRefreshClick()">

        <span
          *ngIf="refreshing"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true">
        </span>

        Refresh
      </button>
    </div>
  </div>
</div>
